module.exports = __webpack_public_path__ + "img/icon.1b42c5d4.webp";